import Direction from "./direction"

export default class DirectionLeftForm extends Direction {
  protected snappableCommands(width: number, height: number, flanged: boolean): [string[], string[]] {
    const offset = this.flangedOffset

    const aw = height / 2
    const top = -(height / 2)
    const bottom = height / 2
    const left = -(width / 2)
    const right = width / 2

    const side = [this.pathMoveTo(right, top)]
    side.push(this.pathLineToAbs(right, bottom))

    const rest = [this.pathMoveTo(right, bottom)]

    if (height >= width * 2) {
      rest.push(this.pathLineToAbs(left, 0))
      rest.push(this.pathLineToAbs(right, top))
    } else {
      if (flanged) {
        // bottom flanged extra
        rest.push(this.pathLineToAbs(right - offset, bottom + offset))
        rest.push(this.pathLineToAbs(left + aw + offset, bottom + offset))
      }

      rest.push(this.pathLineToAbs(left + aw, bottom))
      rest.push(this.pathLineToAbs(left, 0))
      rest.push(this.pathLineToAbs(left + aw, top))

      if (flanged) {
        // top flanged extra
        rest.push(this.pathLineToAbs(left + aw + offset, top - offset))
        rest.push(this.pathLineToAbs(right - offset, top - offset))
      }

      rest.push(this.pathLineToAbs(right, top))
    }

    return [side, rest]
  }
}
